import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { i18nReducer } from 'react-redux-i18n';
import configuration from '@peoplenet/vi-components-ui/src/app/configuration/configurationReducer';
import dashboard from '@peoplenet/vi-components-ui/src/Dashboard/DashboardReducer';
import downloadVideo from '@peoplenet/vi-components-ui/src/DownloadVideo/DownloadVideoReducer';
import dvr from '@peoplenet/vi-components-ui/src/DVRhealth/DVRhealthReducer';
import dvrFilter from '@peoplenet/vi-components-ui/src/DVRhealth/filters/HealthFiltersReducer';
import dvrSnapshots from '@peoplenet/vi-components-ui/src/DVRSnapshots/DVRSnapshotsReducer';
import library from '@peoplenet/vi-components-ui/src/Library/LibraryReducer';
import libraryFilters from '@peoplenet/vi-components-ui/src/LibraryFilter/libraryFilterReducer';
import notification from '@peoplenet/vi-components-ui/src/Notification/NotificationReducer';
import onDemand from '@peoplenet/vi-components-ui/src/OnDemand/OnDemandReducer';
import player from '@peoplenet/vi-components-ui/src/reducers/player';
import featureHub from '@peoplenet/vi-components-ui/src/FeatureHub/FeatureHubReducer';
import report from '@peoplenet/vi-components-ui/src/report/ReportReducer';
import reportFilter from '@peoplenet/vi-components-ui/src/report/filters/ReportFiltersReducer';
import filterReducer from '@peoplenet/vi-components-ui/src/components/DesktopFilter/filterReducer';
import user from '@peoplenet/vi-components-ui/src/app/user/UserReducer';
import userSettings from '@peoplenet/vi-components-ui/src/UserSettings/UserSettingsReducer';
import videoTagging from '@peoplenet/vi-components-ui/src/reducers/videoTagging';
import resetPassword from './resetPassword/ResetPasswordReducer';
import customer from './customer/CustomerReducer';
import security from './security/SecurityReducer';
import globalNotification from './globalNotification/GlobalNotificationReducer';
import firstTimeSetup from './firstTimeSetup/FirstTimeSetupReducer';
import system from './system/SystemReducer';

export default (history) =>
  combineReducers({
    configuration,
    security,
    system,
    filterReducer,
    customer,
    dashboard,
    downloadVideo,
    dvr,
    dvrFilter,
    dvrSnapshots,
    featureHub,
    firstTimeSetup,
    globalNotification,
    library,
    libraryFilters,
    i18n: i18nReducer,
    notification,
    onDemand,
    player,
    report,
    reportFilter,
    resetPassword,
    router: connectRouter(history),
    user,
    userSettings,
    videoTagging,
  });
